// extracted by mini-css-extract-plugin
export default {"scope":"SlK4y","scope--is-loading":"_7pBil","scope--is-inline":"f952Y","spinner":"_1HHUB","spin":"g9Y3M","message":"_7zOgb"};